import { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

const useCustomHook = () => {

  const status = {
    'PARTICIPATION_TENDERS': {
      EDIT_INFO: 0,
      INFO: 0,
      REGISTER_INQUIRY: 0,
      REGISTER_COLLATERAL: 1,
      COLLATERAL_INQUIRY: 1,
      REGISTER_CONTRACT: 2,
      SIGNATURE_CONTRACT: 2,
      FILING: 3,
      PENDING_TO_REGISTER: 4,
      REGISTERED: 4,
      UNREGISTERED: 4,
    },
    'CASH_PARTICIPATION_TENDERS': {
      EDIT_INFO: 0,
      INFO: 0,
      REGISTER_INQUIRY: 0,
      REGISTER_CONTRACT: 1,
      SIGNATURE_CONTRACT: 1,
      FILING: 2,
      PENDING_TO_REGISTER: 3,
      REGISTERED: 3,
      UNREGISTERED: 3,
    }
  };
  const stepperTitles = {
    'PARTICIPATION_TENDERS': [
      { label: 'بررسی مدارک' },
      { label: 'بررسی وثیقه ' },
      { label: 'ایجاد و امضا قرارداد' },
      { label: 'تشکیل پرونده' },
      { label: 'صدور ضمانت‌نامه' },
    ],
    'CASH_PARTICIPATION_TENDERS': [
      { label: 'بررسی مدارک' },
      { label: 'ایجاد و امضا قرارداد' },
      { label: 'تشکیل پرونده' },
      { label: 'صدور ضمانت‌نامه' },
    ],
  }
  const pageTitle = {
    'PARTICIPATION_TENDERS': 'مشاهده جزئیات ضمانت‌نامه شرکت در مناقصه (بر اساس رتبه اعتبارسنجی در بانک پاسارگاد)',
    'CASH_PARTICIPATION_TENDERS': 'مشاهده جزئیات ضمانت‌نامه شرکت در مناقصه (با 100% سپرده نقدی)',
  }
  const WarrantyId = useParams(); // id web service (entity ID)
  const [activeStep, setActiveStep] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [copyStep, setCopyStep] = useState(0);
  const [result, setResult] = useState(null);
  const [warrantyType, setWarrantyType] = useState('');
  const navigate = useNavigate();
  const [isError, setIsError] = useState(false);
  return {
    status,
    WarrantyId,
    activeStep, setActiveStep,
    isLoading, setIsLoading,
    copyStep, setCopyStep,
    result, setResult,
    warrantyType, setWarrantyType,
    navigate,
    stepperTitles,
    isError, setIsError,
    pageTitle,
  };
};

export default useCustomHook;
